import React, { useEffect, useState } from "react";
import {
  getMessageForVendorRequest,
  initiateOrdersOmni,
  initiateOrdersOSI,
  processOrdersFama,
  processOrdersInformData,
  processOrdersOSI,
  processOrdersSterling,
} from "../../services/vendorService";
import { ProcessableOrder } from "../../interfaces/order";

interface ProcessOrdersConfirmationProps {
  vendorID: number;
  orders: ProcessableOrder[];
  onClose: (success?: boolean, message?: string) => void;
}

const ProcessOrdersConfirmation: React.FC<ProcessOrdersConfirmationProps> = ({
  vendorID,
  orders,
  onClose,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    const handleProcessOrders = async () => {
      try {
        setLoadingSpinner(true);
        const criminalDetailIDs = Object.values(orders).flatMap(
          (order) => order.criminalDetailIDs || [],
        );

        const subscriptionDetailIDs = Object.values(orders).flatMap(
          (order) => order.subscriptionDetailIDs || [],
        );

        if (vendorID === 1 || vendorID === 3) {
          //oxford, samba
          const responseUrl = await processOrdersOSI(
            vendorID,
            criminalDetailIDs,
            subscriptionDetailIDs,
          );
          if (responseUrl) {
            const pdfUrl = URL.createObjectURL(responseUrl);
            setPdfUrl(pdfUrl);
          } else {
            throw new Error("Failed to generate the report.");
          }
        }
      } catch (error) {
        setErrorMessage("Failed to process the orders.");
        setLoadingSpinner(false);
      } finally {
        setLoadingSpinner(false);
      }
    };

    handleProcessOrders();
  }, [orders, vendorID]);

  const handleInitiateOrders = async () => {
    try {
      setLoadingSpinner(true);
      const criminalDetailIDs = Object.values(orders).flatMap(
        (order) => order.criminalDetailIDs || [],
      );

      const subscriptionDetailIDs = Object.values(orders).flatMap(
        (order) => order.subscriptionDetailIDs || [],
      );
      let message = "";

      if (vendorID === 5) {
        //sterling
        const response = await processOrdersSterling(
          criminalDetailIDs,
          subscriptionDetailIDs,
        );
        message = response.details.join("\n");
      } else if (vendorID === 2) {
        //omni
        await initiateOrdersOmni(criminalDetailIDs, subscriptionDetailIDs);
        message = "Orders sent successfully";
      } else if (vendorID === 1 || vendorID === 3) {
        //oxford, samba
        await initiateOrdersOSI(
          vendorID,
          criminalDetailIDs,
          subscriptionDetailIDs,
        );
        message = "Orders marked as initiated.";
      } else if (vendorID === 13) {
        //fama
        const response = await processOrdersFama(
          criminalDetailIDs,
          subscriptionDetailIDs,
        );
        message = response.details.join("\n");
      } else if (vendorID === 4) {
        //informData
        const response = await processOrdersInformData(
          criminalDetailIDs,
          subscriptionDetailIDs,
        );
        message = getMessageForVendorRequest(response);
      }
      onClose(true, message);
    } catch (error: any) {
      setErrorMessage(`Failed to process orders. ${error.message}`);
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose(false)}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose(false)}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Process Orders</h2>
          <div>Are you sure you would like to process these orders? </div>
          {vendorID === 2 && (
            <div>
              FIPS codes will be automatically found based on the county and
              state combinations provided.
            </div>
          )}
          {vendorID === 5 ||
          vendorID === 2 ||
          vendorID === 13 ||
          vendorID === 4 ? (
            <div>Orders will be sent to vendor and marked as initiated. </div>
          ) : (
            <div>Orders will be marked as initiated.</div>
          )}
        </div>

        {(vendorID === 1 || vendorID === 3) && (
          <>
            <br></br>
            <div className="error">
              PRINT REPORT BEFORE SELECTING PROCESS ORDERS
            </div>
            <div className="field-long" style={{ flex: "0 0 100%" }}>
              <label className="field-label">Generated Order Report:</label>
              <div className="field-input">
                {pdfUrl ? (
                  <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                    View Report{" "}
                    <i className="btn-icon bi bi-box-arrow-up-right"></i>
                  </a>
                ) : (
                  <p>Generating report...</p>
                )}
              </div>
            </div>
          </>
        )}
        <div className="filter-actions">
          <button className="smbtn btn-grey" onClick={() => onClose(false)}>
            Cancel
          </button>
          <button className={`smbtn btn-green`} onClick={handleInitiateOrders}>
            Process Orders
          </button>
        </div>
        <br></br>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default ProcessOrdersConfirmation;
